import { render, staticRenderFns } from "./NotificationEdit.vue?vue&type=template&id=46ed6190&scoped=true&"
import script from "./NotificationEdit.vue?vue&type=script&lang=js&"
export * from "./NotificationEdit.vue?vue&type=script&lang=js&"
import style0 from "./NotificationEdit.vue?vue&type=style&index=0&id=46ed6190&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ed6190",
  null
  
)

export default component.exports